import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import {staticContentsImagePathOnly as BASE_IMAGE_PATH_ONLY} from '../configs/const';
class Rules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMaintanance: false,
            language: "english",
            url: `https://rules.${BASE_IMAGE_PATH_ONLY}/englishrules.html`
        };
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }

    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Rules</p>
                            </div>
                            <div className="allreport col3">
                                <div ClassName="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2 text-center">
                                        <div className="btn-group mb-2" role="group" aria-label="Basic example">
                                            <button className={this.state.language === "english" ? "btn place-bet-btn rulesselected" : "btn place-bet-btn "} onClick={() => { this.setState({ url: `https://rules.${BASE_IMAGE_PATH_ONLY}/englishrules.html`, language: "english" }) }}>English</button>
                                            <button className={this.state.language === "hindi" ? "btn place-bet-btn rulesselected ml-1" : "btn place-bet-btn ml-1"} onClick={() => { this.setState({ url: `https://rules.${BASE_IMAGE_PATH_ONLY}/hindirules.html`, language: "hindi" }) }}>Hindi</button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div ClassName="row">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <iframe src={this.state.url} width="100%" height="100%" className="rulesiframe" frameBorder="0px" title="Game Rules"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Rules);